"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class PriceSpiderApi {
    binInit(ps_key, ps_language, ps_country, ps_url, ps_trackUrl, ps_versionUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            this.binDistroy();
            if (!document.querySelector('meta[name="ps-key"]')) {
                const key = document.createElement('meta');
                key.name = 'ps-key';
                key.content = ps_key;
                document.head.appendChild(key);
            }
            if (!document.querySelector('meta[name="ps-language"]')) {
                const language = document.createElement('meta');
                language.name = 'ps-language';
                language.content = ps_language;
                document.head.appendChild(language);
            }
            if (!document.querySelector('meta[name="ps-country"]')) {
                const country = document.createElement('meta');
                country.name = 'ps-country';
                country.content = ps_country;
                document.head.appendChild(country);
            }
            if (!document.querySelector(`script[id="pricespider-script"]`) && ps_url) {
                const script = document.createElement('script');
                script.src = ps_url;
                script.id = 'pricespider-script';
                script.async = true;
                document.body.appendChild(script);
            }
        });
    }
    binDistroy() {
        var _a, _b, _c, _d;
        const scriptElements = document.getElementsByTagName('script');
        for (let i = 0; i < scriptElements.length; i++) {
            const scriptElement = scriptElements[i];
            if (scriptElement.src.includes('pricespider')) {
                scriptElement.remove();
            }
        }
        const linkElements = document.getElementsByTagName('link');
        for (let i = 0; i < linkElements.length; i++) {
            const linkElement = linkElements[i];
            if (linkElement.href.includes('pricespider')) {
                linkElement.remove();
            }
        }
        (_a = document.querySelector(`script[id="pricespider-script"]`)) === null || _a === void 0 ? void 0 : _a.remove();
        (_b = document.querySelector(`script[id="pricespider-version-script"]`)) === null || _b === void 0 ? void 0 : _b.remove();
        (_c = document.querySelector(`script[id="pricespider-track-script"]`)) === null || _c === void 0 ? void 0 : _c.remove();
        (_d = document.querySelector(`script[id="pricespider-script"]`)) === null || _d === void 0 ? void 0 : _d.remove();
    }
    binClick(obj) {
        var _a;
        (_a = document.querySelector(`#product-${obj['dataset']['value']}`)) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('click'));
    }
}
exports.default = PriceSpiderApi;
